import React from "react";

import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import { useTheme, styled } from "@mui/material/styles";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Table from "@mui/material/Table";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";

import CloseCircleOutline from "mdi-material-ui/CloseCircleOutline";

const MUITableCell = styled(TableCell)(({ theme }) => ({
  borderBottom: 0,
  padding: `${theme.spacing(1, 0)} !important`,
}));

const UserModal = (props) => {
  const { open, handleClose, profileList } = props;
  const theme = useTheme();

  return (
    <Dialog
      open={open}
      scroll="body"
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
      sx={{
        '& .css-187z3wh-MuiPaper-root-MuiDialog-paper': {
          width: '600px',
          minHeight: '360px'
        }
      }}
    >
      <DialogTitle
        id="form-dialog-title"
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography sx={{ fontWeight: "bold", fontSize: "1.2rem !important" }}>
          User Profile
        </Typography>
        <Box
          sx={{
            cursor: "pointer",
          }}
          onClick={handleClose}
        >
          <CloseCircleOutline
            fontSize="small"
            sx={{ stroke: "#ffffff", strokeWidth: 1 }}
            style={{
              color: theme.palette.secondary.main,
            }}
          />
        </Box>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
          <Grid container spacing={1}>
            <Grid item>
              <div>
                <TableContainer>
                  <Table size="medium" aria-label="a dense table">
                    <TableBody>
                      <TableRow>
                        <MUITableCell>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <Typography variant="body1">Name</Typography>
                            <Typography variant="body1">:</Typography>
                          </Box>
                        </MUITableCell>
                        <MUITableCell>
                          <Typography variant="body2" sx={{ m: 2 }}>
                            {profileList?.first_name || '-'}
                          </Typography>
                        </MUITableCell>
                      </TableRow>

                      <TableRow>
                        <MUITableCell>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <Typography variant="body1">Email</Typography>
                            <Typography variant="body1">:</Typography>
                          </Box>
                        </MUITableCell>
                        <MUITableCell>
                          <Typography variant="body2" sx={{ m: 2 }}>
                            {profileList?.email || '-'}
                          </Typography>
                        </MUITableCell>
                      </TableRow>
                      <TableRow>
                        <MUITableCell>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <Typography variant="body1">
                              Phone number
                            </Typography>
                            <Typography variant="body1">:</Typography>
                          </Box>
                        </MUITableCell>
                        <MUITableCell>
                          <Typography variant="body2" sx={{ m: 2 }}>
                            {profileList?.country_code
                              ? `+${profileList?.country_code}-${profileList?.phone_no}`
                              : "-"}
                          </Typography>
                        </MUITableCell>
                      </TableRow>
                      <TableRow>
                        <MUITableCell>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <Typography variant="body1">Member type</Typography>
                            <Typography variant="body1">:</Typography>
                          </Box>
                        </MUITableCell>
                        <MUITableCell>
                          <Typography variant="body2" sx={{ m: 2 }}>
                            {profileList?.member_type === 0
                              ? "Non Member"
                              : "Member"}
                          </Typography>
                        </MUITableCell>
                      </TableRow>
                      <TableRow>
                        <MUITableCell>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <Typography variant="body1">Address</Typography>
                            <Typography variant="body1">:</Typography>
                          </Box>
                        </MUITableCell>
                        <MUITableCell>
                          <Typography variant="body2" sx={{ m: 2 }}>
                            {profileList?.address || '-'}
                          </Typography>
                        </MUITableCell>
                      </TableRow>
                      <TableRow>
                        <MUITableCell>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <Typography variant="body1" sx={{ minWidth: 150 }}>
                              Business name
                            </Typography>
                            <Typography variant="body1">:</Typography>
                          </Box>
                        </MUITableCell>
                        <MUITableCell>
                          <Typography variant="body2" sx={{ m: 2 }}>
                            {profileList?.business_name || '-'}
                          </Typography>
                        </MUITableCell>
                      </TableRow>
                      <TableRow>
                        <MUITableCell>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <Typography variant="body1">
                              Business details
                            </Typography>
                            <Typography variant="body1">:</Typography>
                          </Box>
                        </MUITableCell>
                        <MUITableCell>
                          <Typography variant="body2" sx={{ ml: 2 }}>
                            {profileList?.business_details || '-'}
                          </Typography>
                        </MUITableCell>
                      </TableRow>
                      <TableRow>
                        <MUITableCell>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <Typography variant="body1">Website</Typography>
                            <Typography variant="body1">:</Typography>
                          </Box>
                        </MUITableCell>
                        <MUITableCell>
                          <Typography variant="body2" sx={{ ml: 2 }}>
                            {profileList?.website || '-'}
                          </Typography>
                        </MUITableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default UserModal;
